import {Component, OnInit} from '@angular/core';
import {UserService} from "../user.service";
import {LayoutService} from "../../layout/layout.service";
import {AuthService} from "../../../+auth/auth.service";

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user:any;

  profile:any; // Auth0

  constructor(
    private userService: UserService,
              private layoutService: LayoutService,
    public auth: AuthService) {
  }

  ngOnInit() {
    // this.userService.getLoginInfo().subscribe(user => {
    //   this.user = user
    // })

    if (this.auth.userProfile) {
      this.profile = this.auth.userProfile;
        console.log('profile = ', this.profile);
    } else {
      this.auth.getProfile((err, profile) => {
        this.profile = profile;
          console.log('profile = ', this.profile);
      });
    }


  }

    // My ver - working for Auth0
    // ngOnInit() {
    //     // this.userService.getLoginInfo().subscribe(user => {
    //     //   this.user = user
    //     //     console.log('login user = ', this.user);
    //     // })
    //     this.userService.getLoginInfo().subscribe(user => {
    //         this.user = user
    //     });
    //     console.log('login user = ', this.user);
    //
    // }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/user/login-info/login-info.component.ts